import React, { useEffect, useState, useContext } from "react";
import { PatientContext, UserContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Link } from "react-router-dom";

import { Row, Col } from "react-bootstrap";
import ComponentWrapper from "./ComponentWrapper";
import LoadingSpinner from "../UIComponents/LoadingSpinner";
import EditIcon from "../../images/edit.svg";

import { getGoals } from "../../api/TBIRequests";

const GoalList = ({ userType }) => {
  const { user } = useContext(UserContext);
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  const [goals, setGoals] = useState(undefined);

  useEffect(() => {
    if (patient) {
      let isComponentMounted = true;

      getGoals({
        patientId: patient.patientId,
        therapistId:
          user.userType === "Therapist"
            ? user.userId
            : user.userType === "provider"
              ? (patient.caregiverId ?? null)
              : null,
      })
        .then((result) => {
          if (isComponentMounted) {
            setGoals(result.data[0]);
          }
        })
        .catch((err) => {
          if (isComponentMounted) {
            console.log(err);
          }
        });

      return () => {
        isComponentMounted = false;
      };
    }
  }, [patient]);

  return (
    <ComponentWrapper>
      {goals ? (
        <div>
          <Row>
            <Col md={4}>
              <h6>{t("goals.label")}</h6>
            </Col>
            {user.userType !== "provider" && (
              <Col md={{ span: 3, offset: 5 }}>
                <Link
                  to="/accountSetting/setGoals"
                  className="inline-flex items-center"
                >
                  <img src={EditIcon} alt="edit icon" className="editIcon" />
                  {t("goals.edit")}
                </Link>
              </Col>
            )}
          </Row>
          <div className="goalList">
            <Row className="goalItem">
              <Col sm={1}>1. </Col> <Col>{goals.first_goal}</Col>
            </Row>
            <Row className="goalItem">
              <Col sm={1}>2. </Col> <Col>{goals.second_goal}</Col>
            </Row>
            <Row className="goalItem">
              <Col sm={1}>3. </Col> <Col>{goals.third_goal}</Col>
            </Row>
          </div>
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </ComponentWrapper>
  );
};

export default GoalList;